import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoalResponseDto } from '../../../store/landscapeAPI/goal/dto/response/goal-response.dto';
import { Button, Label } from '../../atoms';
import { ReportingDetailsGoalsOrganism } from '../../organisms';
import BaseTemplate from '../BaseTemplate';

import styles from './ReportingDetailsGoalsTemplate.module.css';

export interface ReportingDetailsGoalsTemplateProps {
  data: GoalResponseDto[];
  handleDeleteGoal: (id: string) => void;
}

const ReportingDetailsGoalsTemplate: FC<ReportingDetailsGoalsTemplateProps> = ({
  data,
  handleDeleteGoal,
}) => {
  const navigate = useNavigate();

  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Progress Reporting - Goals" size="lg" />
        <Button
          variant={'dark'}
          onClick={() => navigate('/reporting-details/goals/add')}
        >
          Add Goal
        </Button>
      </div>
      <ReportingDetailsGoalsOrganism
        data={data}
        handleDeleteGoal={handleDeleteGoal}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsGoalsTemplate;
